import "./Login.scss";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { MdClose } from "react-icons/md";
import axios from "axios";
import jwtDecode from "jwt-decode";
import ConfirmModal from "../../components/ConfirmModal";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

function Userlogin() {
  const [userid, setUserId] = useState("");
  const [userpwd, setUserPwd] = useState("");
  const [checkPwdMsg, setCheckPwdMsg] = useState("");
  const [checkIdMsg, setCheckIdMsg] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);

  const heighL = useRef();
  const btnWidth = useRef();

  // 로그인 이벤트 핸들러
  const onChangeId = ({ target: { value } }) => {
    setCheckIdMsg("");
    setUserId(value);
  };
  const onChangePwd = ({ target: { value } }) => {
    setCheckPwdMsg("");
    setUserPwd(value);
  };
  const [passwordType, setPasswordType] = useState({
    type: "password",
    visible: false,
  });
  const handlePasswordType = (e) => {
    setPasswordType(() => {
      if (!passwordType.visible) {
        return { type: "text", visible: true };
      }
      return { type: "password", visible: false };
    });
  };

  // 모달
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    setLoginFailed(false);
  };

  // 제출
  const handleSubmit = async (e) => {
    e.preventDefault();
    await LoginOK();
  };

  const LoginOK = async () => {
    const params = new URLSearchParams();
    params.append("id", userid.toLowerCase());
    params.append("password", userpwd);
    await axios
      .post("/api/applicant-login", params)
      .then((response) => {
        window.sessionStorage.setItem("token", response.data.jwt);
      })
      .catch((error) => {
        console.log("error", error);
      });

    const isLogin = window.sessionStorage.getItem("token");
    if (isLogin !== null) {
      let jwtdec = jwtDecode(isLogin);
      if (jwtdec.obj.state.toUpperCase() === "APPLIED") {
        window.sessionStorage.setItem("applied", true);
      } else {
        window.sessionStorage.setItem("applied", false);
      }
      window.location.replace("/");
    } else {
      window.sessionStorage.clear();
      // setLoginFailed(true);
    }
  };

  let [finder, setFinder] = useState("findId");
  let content = null;
  if (finder === "findPw") {
    content = <FindPw />;
  } else if (finder === "findId") {
    content = <FindId />;
  }

  function sliding() {
    heighL.current.style.width = btnWidth.current.offsetWidth + "px";
    heighL.current.style.height = btnWidth.current.offsetHeight + "px";
    heighL.current.style.left = btnWidth.current.offsetWidth + "px";
  }
  function sliding2() {
    heighL.current.style.width = btnWidth.current.offsetWidth + "px";
    heighL.current.style.height = btnWidth.current.offsetHeight + "px";
    heighL.current.style.left = 0 + "px";
  }
  function delBtnBg() {
    let delbtnBg = document.querySelector(".btns button:nth-child(1)");
    delbtnBg.style.background = "transparent";
  }

  return (
    <>
      {showModal ? (
        <div className="popup_bg" onClick={closeModal}>
          <div className="popup" onClick={(e) => e.stopPropagation()}>
            <div className="pophead">
              아이디/비밀번호 찾기
              <span onClick={closeModal}>
                <MdClose />
              </span>
            </div>

            <div className="btns">
              <button
                ref={btnWidth}
                onClick={() => {
                  setFinder("findId");
                  sliding2();
                  delBtnBg();
                }}
              >
                아이디 찾기
              </button>
              <button
                ref={btnWidth}
                onClick={() => {
                  setFinder("findPw");
                  sliding();
                  delBtnBg();
                }}
              >
                비밀번호 찾기
              </button>
              <span ref={heighL} className="hL"></span>
            </div>
            {content}
          </div>
        </div>
      ) : null}

      {loginFailed ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"로그인 실패"}
          content={`로그인 정보를 다시 확인 하십시오.`}
        />
      ) : null}

      <div className="contain login_contain">
        <div className="login_wrap login_wrap2">
          {/* <h1>사용자 로그인</h1> */}
          <form onSubmit={handleSubmit}>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                name="userid"
                onChange={onChangeId}
                placeholder="ID"
              />
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type={passwordType.type}
                name="userpwd"
                onChange={onChangePwd}
                placeholder="Password"
              />
            </div>
            <div className="input_wrap">
              <button type="submit" className="btn_color">
                신청기관 로그인
              </button>
            </div>
          </form>

          <div className="find">
            <p>
              계정이 없으신가요?<Link to="/usersignup">회원가입</Link>
            </p>
            <p>
              아이디, 비밀번호를 찾으시겠습니까?
              <span onClick={openModal}>ID·PW찾기</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

function FindId() {
  // react hook form
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const staffEmail1 = watch("userEmail", "");
  const companyRegNum = watch("companyRegNum", "");

  const onSubmitFindId = async () => {
    try {
      await axios.get(`/api/applicant-find-id`, {
        params: {
          staffEmail: staffEmail1,
          companyRegNum: companyRegNum,
        },
      });
      Swal.fire("완료", "이메일을 확인해 주세요.", "success");
    } catch (error) {
      if (error.response.status === 404) {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "입력하신 정보를 확인해 주세요.",
        });
      }
      console.log(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitFindId)}>
      <div className="input_bg">
        <div className="input_wrap">
          <input
            className="input_box"
            type="text"
            placeholder="사업자등록번호(-없이) 입력해 주세요."
            {...register("companyRegNum", {
              required: "* 사업자등록번호는 필수 입력입니다.",
              pattern: {
                value: /^[0-9]{10}$/,
                message: "* 사업자등록번호는 10자리 숫자로 구성되어야 합니다.",
              },
            })}
          />
        </div>
        <div className="error_msg">
          {errors.companyRegNum && <p>{errors.companyRegNum?.message}</p>}
        </div>
        <div className="input_wrap">
          <input
            className="input_box"
            type="text"
            placeholder="이메일을 입력해 주세요."
            {...register("userEmail", {
              required: "* 이메일은 필수 입력입니다.",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "* 이메일 형식을 확인하세요.",
              },
            })}
          />
        </div>
        <div className="error_msg">
          {errors.userEmail && <p>{errors.userEmail?.message}</p>}
        </div>
        {staffEmail1.length === 0 ||
        companyRegNum.length === 0 ||
        errors.userEmail ||
        errors.userCeoName ? (
          <button className="btn_none">아이디찾기</button>
        ) : (
          <button className="btn_color">아이디찾기</button>
        )}
      </div>
    </form>
  );
}

function FindPw() {
  // react hook form
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const userId = watch("userId", "");
  const staffEmail1 = watch("userEmail", "");

  const onSubmitFindPw = async () => {
    try {
      await axios.get(`/api/applicant-find-pw`, {
        params: {
          id: userId,
          staffEmail: staffEmail1,
        },
      });
      Swal.fire("완료", "이메일을 확인해 주세요.", "success");
    } catch (error) {
      if (error.response.status === 404) {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "입력하신 정보를 확인해 주세요.",
        });
      }
      console.log(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitFindPw)}>
      <div className="input_bg">
        <div className="input_wrap">
          <input
            className="input_box"
            type="text"
            placeholder="아이디를 입력해 주세요."
            {...register("userId", {
              required: "* 아이디는 필수 입력입니다.",
            })}
          />
        </div>
        <div className="error_msg">
          {errors.userId && <p>{errors.userId?.message}</p>}
        </div>
        <div className="input_wrap">
          <input
            className="input_box"
            type="text"
            placeholder="이메일을 입력해 주세요."
            {...register("userEmail", {
              required: "* 이메일은 필수 입력입니다.",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "* 이메일 형식을 확인하세요.",
              },
            })}
          />
        </div>
        <div className="error_msg">
          {errors.userEmail && <p>{errors.userEmail?.message}</p>}
        </div>
        {userId.length === 0 ||
        staffEmail1.length === 0 ||
        errors.userEmail ||
        errors.userId ? (
          <button className="btn_none">비밀번호찾기</button>
        ) : (
          <button className="btn_color">비밀번호찾기</button>
        )}
      </div>
    </form>
  );
}
export default Userlogin;
